import React, { useEffect, useState } from 'react';
import './Works.css';

import coding from '../../asset/coding_text.svg';
import video from '../../asset/video_text.svg';
import design from '../../asset/design_text.svg';
import drawing from '../../asset/drawing_text.svg';

import Coding from "./works/Coding";
import Video from "./works/Video";
// import Photo from "./works/Photo";
import Design from "./works/Design";
import Drawing from "./works/Drawing";

function Works({ showWorksModal }) {
    const worksWindowContents = [
        { id: 0, image: coding, content: "WEB DEVELOPMENT" },
        { id: 1, image: video, content: "VIDEO PRODUCTION" },
        // { id: 2, image: photo, content: "PHOTOGRAPHY" },
        { id: 3, image: design, content: "GRAPHIC DESIGN" },
        { id: 4, image: drawing, content: "DRAWING" },
    ];

    const [worksSelectedTab, setWorksSelectedTab] = useState(0); // 현재 선택된 탭
    const [previousTab, setPreviousTab] = useState(null); // 이전에 선택된 탭

    const handleTabClick = (index) => {
        if (index !== worksSelectedTab) {
            setPreviousTab(worksSelectedTab); // 현재 선택된 탭을 이전 탭으로 저장
            setWorksSelectedTab(index); // 새로운 탭 선택
        }
    };

    useEffect(() => {
        setWorksSelectedTab(0);
    }, [showWorksModal]);

    return (
        <div>
            {showWorksModal && (
                <div>
                    <div className="works-modal-shadow"></div>
                    <div className="works-modal">
                        <div className="works-tabs">
                            {worksWindowContents.map((window, index) => (
                                <div
                                    key={window.id}
                                    className={`tab ${worksSelectedTab === index ? 'selected' : ''}`}
                                    onClick={() => handleTabClick(index)}
                                >
                                    <div className="tab-container">
                                        {/* 이미지만 애니메이션 적용 */}
                                        {worksSelectedTab === index ? (
                                            <img
                                                src={window.image}
                                                alt={window.content}
                                                className="slidingOut"
                                            />
                                        ) : previousTab === index ? (
                                            <img
                                                src={window.image}
                                                alt={window.content}
                                                className="slidingIn"
                                            />
                                        ) : (
                                            <img
                                                src={window.image}
                                                alt={window.content}
                                            />
                                        )}
                                        <span className="tab-text">{window.content}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="works-content">
                            {console.log(worksWindowContents[worksSelectedTab].content, showWorksModal, worksSelectedTab)}
                            {
                                worksWindowContents[worksSelectedTab].content === "WEB DEVELOPMENT" ? (<Coding />) : 
                                worksWindowContents[worksSelectedTab].content === "VIDEO PRODUCTION" ? (<Video />) :
                                // worksWindowContents[worksSelectedTab].content === "PHOTOGRAPHY" ? (<Photo />) :
                                worksWindowContents[worksSelectedTab].content === "GRAPHIC DESIGN" ? (<Design />) :
                                worksWindowContents[worksSelectedTab].content === "DRAWING" ? (<Drawing />) : (<div></div>)
                            }
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Works;